import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState, useContext } from "react";
import $ from "jquery"
import calllogo from "../../assets/images/callfor-logo.png"
import { Avatar, Badge } from 'antd';
// import { activeSessionCheck } from '../../util/auth';
import { enquireScreen } from 'enquire-js';



const UserHeader = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [menuItems, setmenuItems] = useState([
        {
            key: 1,
            name: "Home",
            route: "/"
        },
        {
            key: 2,
            name: "About us",
            route: "/about-us"
        },
        {
            key: 3,
            name: "Services",
            route: "/services"
        },
        {
            key: 3,
            name: "Products",
            route: "#"
        },
        {
            key: 3,
            name: "Contact us",
            route: "#"
        },
        {
            key: 3,
            name: "AllEyeSeeing Security",
            route: "#"
        }
    ]);
    const location = useLocation();
    let url = location?.pathname;



    const toggleMobileMenuVisibility = () => {
        // const url = location.pathname; // Now this will always have the latest path
        //const url = window.location.pathname;
        // console.log(path)
        // console.log(url);
        if (url.includes("userindex")) {
            $("#kobo-side-menu").toggle('slow');
        } else {
            $(`#${'site-main-mobile-menu'}`).animate({ width: 400 }, 400);
        }
    };
    const hotNavigate = () => {
        window.location.href = "/userindex"
    }
    const dashNav = () => {
        // const url = location.pathname; // Now this will always have the latest path
        //const url = window.location.pathname;
        // console.log(path)

        $("#kobo-side-menu").toggle('slow');

    };

    const closeMobileMenu = () => {
        const menuElement = document.getElementById('site-main-mobile-menu');
        menuElement.style.width = '0px';
    }
    function openSlideMenu() {
        document.getElementById('menu-call').style.width = '250px';
        document.getElementById('content-call').style.marginLeft = '250px';
    }

    function closeSlideMenu() {
        document.getElementById('menu-call').style.width = '0';
        document.getElementById('content-call').style.marginLeft = '0';
    }
    useEffect(() => {
        //url = location?.pathname;
        enquireScreen((b) => {
            setIsMobile(b)
        });
    }, [])


    return (
        <>

            {/* Header Section Start */}
            <div>
                <img className="back-image-fade" src={calllogo} style={{ position: "absolute", bottom: "1em" }} />
            </div>
            <div className="header-section header-shadow sticky-header section">
                <div className="header-inner" style={{ position: "fixed", width: "100%", zIndex: 99 }}>
                    <div className="cust-cont-cal position-relative">
                        <div className="row justify-content-between align-items-center ml_cus_nav">
                            <div className="col-xl-2 col-auto">
                                <div className="header-logo">
                                    <Link to={"/"}>
                                        <span className='outfit-700 logo-nav-text' style={{ color: "#076fcc", display: "inline-flex", alignItems: "center" }}>
                                            <img className="kobo-logo-nav" src={calllogo} alt="Kobokist Logo" />

                                            <span className='gilroy-800' style={{ color: "#000", fontSize:"20px" }}>Callforatech</span></span>
                                        {/* <img className="dark-logo kobo-logo-nav" src={kobologo} alt="Kobokist Logo" /> */}
                                        {/* <img className="light-logo kobo-logo-nav" src={kobologo} alt="Kobokist Logo" /> */}
                                    </Link>
                                </div>
                            </div>
                            <div className="col d-none d-xl-block position-static ml_cus_menu">
                                <nav className="site-main-menu menu-hover-1">
                                    <ul>
                                        {menuItems.map((x, i) => {
                                            return(
                                                <li className="has-children">
                                                    <Link to={x?.route} className="jakarta"><span className="menu-text">{x.name}</span></Link>
                                                    {/* <span className="menu-toggle"><i className="far fa-angle-down" /></span> */}
                                                </li>
                                            )
                                        })}
                                        {/* <li className="has-children position-static">
                                            <Link to="/" className="jakarta"><span className="menu-text">Home</span></Link>
                                            <span className="menu-toggle"><i className="far fa-angle-down" /></span>
                                        </li>
                                        <li className="has-children">
                                            <Link to="/about-us"><span className="menu-text">About us</span></Link>
                                            <span className="menu-toggle"><i className="far fa-angle-down" /></span>
                                        </li>
                                        <li className="has-children">
                                            <Link to="/services"><span className="menu-text">Services</span></Link>
                                            <span className="menu-toggle"><i className="far fa-angle-down" /></span>
                                        </li>
                                        <li className="has-children">
                                            <a href="page-contact.html"><span className="menu-text">Products</span></a>
                                            <span className="menu-toggle"><i className="far fa-angle-down" /></span>
                                        </li>
                                        <li className="has-children">
                                            <a href="page-contact.html"><span className="menu-text">Contact us</span></a>
                                            <span className="menu-toggle"><i className="far fa-angle-down" /></span>
                                        </li>
                                        <li className="has-children">
                                            <a href="page-contact.html"><span className="menu-text">
                                                AllEyeSeeing Security
                                            </span></a>
                                            <span className="menu-toggle"><i className="far fa-angle-down" /></span>
                                        </li> */}

                                    </ul>
                                </nav>
                            </div>
                            <div className="col-xl-1 col-auto responsive-control">
                                <a href="#" className="btn btn-primary btn-sm gilroy-600" style={{ height: "33px", paddingLeft: "13px", paddingRight: "13px" }}>Sign up</a>
</div>

                            {/* Header Main Menu End */}
                            {/* Header Right Start */}
                            {/* <div className="col-xl-1 col-auto res_show">
                                <a style={{ textDecoration: 'underline' }} href="page-register.html" className="jakarta">Register</a>
                            </div> */}
                          
                            <div className="col-xl-1 col-auto">
                                {/* <button class="btn btn-primary res_show">Enroll</button> */}
                                <div className="header-right">
                                    <div className="inner">
                                        <div className="header-search">
                                            {/* <button class="header-search-toggle"><i class="far fa-search"></i></button>
                                          <div class="header-search-form">
                                              <form action="#">
                                                  <input type="text" placeholder="Search...">
                                                      <button><i class="fas fa-search"></i></button>
                                              </form>
                                          </div> */}
                                        </div>
                                        {/* Header Mobile Menu Toggle Start */}
                                        <div className="header-mobile-menu-toggle d-xl-none ml-sm-2">
                                            <button className="toggle" onClick={() => openSlideMenu()}>
                                                <i className="icon-top" />
                                                <i className="icon-middle" />
                                                <i className="icon-bottom" />
                                            </button>
                                        </div>
                                        {/* Header Mobile Menu Toggle End */}
                                    </div>
                                </div>
                            </div>
                            {/* Header Right End */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Header Section End */}
            <div id="main-call">
                <div id="content-call">
                    {/* <span className="slide">
                        <a href="#" onClick={() => openSlideMenu()}>
                            <i className="fas fa-bars" />
                        </a>
                    </span> */}
                    <div id="menu-call" className="call-nav">
                        <a href="#" className="close" onClick={() => closeSlideMenu()}>
                            <i className="fas fa-times" />
                        </a>
                        {menuItems.map((x, i) => {
                            return(
                                <Link onClick={() => closeSlideMenu()} to={x.route} style={{ fontSize: "17px" }}>{x.name}</Link>
                            )
                        })}
                        
                        {/* <a href="#">About</a>
                        <a href="#">Services</a>
                        <a href="#">Portfolio</a>
                        <a href="#">Contact</a> */}
                    </div>
                </div>
            </div>

           

            <div id="site-main-mobile-menu" className="site-main-mobile-menu">
                <div className="site-main-mobile-menu-inner">
                    <div className="mobile-menu-header">
                        {/* <div className="mobile-menu-logo">
                            <a href="#"><img style={{ width: "66px" }} src={koboL2} alt="" /></a>
                        </div> */}
                        <div className="mobile-menu-close">
                            <button className="toggle" onClick={() => closeMobileMenu()}>
                                <i className="icon-top" />
                                <i className="icon-bottom" />
                            </button>
                        </div>
                    </div>
                    <div className="mobile-menu-content" style={{ background: "#223c70" }}>
                        <nav className="kobo-site-mobile-menu">
                            <ul>
                                <li className="has-children position-static">
                                    <Link to="/home-services"><span className="menu-text">Home</span></Link>
                                    {/* <span className="menu-toggle"><i className="far fa-angle-down" /></span> */}
                                </li>
                              
                                <li className="has-children position-static">
                                    <Link to="/more-services"><span className="menu-text">Find a professional</span></Link>
                                </li>
                                <li className="has-children position-static">
                                    <Link to="/subscription-plans"><span className="menu-text">Subscription Plans</span></Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserHeader;